import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWidthWider = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 47.98 28.485",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Bredere",
		transform: "translate(10 -3)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_175",
			"data-name": "Group 175",
			transform: "translate(-5.59 12.766)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_186",
					"data-name": "Rectangle 186",
					width: 35.555,
					height: 1.582,
					transform: "translate(1.662 3.693)"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_173",
					"data-name": "Group 173",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_187",
						"data-name": "Rectangle 187",
						width: 1.582,
						height: 6.33,
						transform: "translate(4.476) rotate(45)"
					}), /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_188",
						"data-name": "Rectangle 188",
						width: 1.582,
						height: 6.33,
						transform: "translate(5.595 7.833) rotate(135)"
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_174",
					"data-name": "Group 174",
					transform: "translate(33.285 0)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_189",
						"data-name": "Rectangle 189",
						width: 1.582,
						height: 6.33,
						transform: "translate(1.119 8.952) rotate(-135)"
					}), /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_190",
						"data-name": "Rectangle 190",
						width: 1.582,
						height: 6.33,
						transform: "translate(0 1.119) rotate(-45)"
					})]
				})
			]
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_176",
			"data-name": "Group 176",
			transform: "translate(0 3)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_200",
				"data-name": "Path 200",
				d: "M34.815,4.582A1.5,1.5,0,0,1,36.4,6.165V28.32A1.5,1.5,0,0,1,34.815,29.9H-6.835A1.5,1.5,0,0,1-8.418,28.32V6.165A1.5,1.5,0,0,1-6.835,4.582h41.65m0-1.582H-6.835A3.174,3.174,0,0,0-10,6.165V28.32a3.174,3.174,0,0,0,3.165,3.165h41.65A3.174,3.174,0,0,0,37.98,28.32V6.165A3.174,3.174,0,0,0,34.815,3Z",
				transform: "translate(0 -3)"
			})
		})]
	})
});
export default SvgWidthWider;
